// extracted by mini-css-extract-plugin
export default {"header":"add-client_header__9JWZe","title":"add-client_title__8sRIG","addButton":"add-client_addButton__OrM1r"};